;(async () => {
  const { default: Swiper } = await import('../../plugins/swiper/swiper')
  import('../../plugins/swiper/swiper.scss')

  Promise.all([import(/* webpackMode: "eager" */ './tab-content-block.scss')]).then(() => {
    $('.widget.tab-content-block').each(function (i, el) {
      $(el).data('widget', new TabContentBlock(el, Swiper))
      $(el).data('widget').init()
    })
  })
})()

function TabContentBlock(el, Swiper) {
  const self = this
  self.el = $(el)
  self.tabsContainer = self.el.find('.js-tabs-container')
  self.tabs = self.tabsContainer.find('[aria-controls]')
  self.tabsSwiper = null
  self.contentSwiper = null
  console.log('tabs', self.tabs)

  self.init = function () {
    if (process.env.NODE_ENV === 'development') {
      console.log('TabContentBlock init', self)
    }
    self.el.css('opacity', 1)

    self.initTabsSwiper()
    self.bindEvents()
  }

  self.bindEvents = function () {
    self.tabs.each(function (i, el) {
      el.addEventListener('click', (e) => self.expandPanel(e.currentTarget))
    })
  }

  self.initTabsSwiper = function () {
    const swiperEl = self.el.find('.tabs-swiper')
    self.tabsSwiper = new Swiper(swiperEl, {
      watchOverflow: true,
      slidesPerView: 'auto',
    })

    // slideTo the active tab
    const activeTabIndex = self.tabs.index(self.tabs.filter('[aria-expanded="true"]'))
    if (activeTabIndex !== -1) {
      self.tabsSwiper.slideTo(activeTabIndex)
    }
  }

  self.expandPanel = function (tab) {
    const isExpanded = tab.getAttribute('aria-expanded') === 'true'

    // If expanded, do nothing
    if (isExpanded) {
      return
    }

    // Expand the tab
    const tabControls = tab.getAttribute('aria-controls') || ''
    const panel = document.getElementById(tabControls)
    tab.setAttribute('aria-expanded', String(!isExpanded))
    panel?.setAttribute('aria-hidden', String(isExpanded))

    window.dbs.globalEvents.emit('tab_revealed', {
      id: tabControls,
    })

    // Collapse all other tabs
    self.tabs.each(function (i, el) {
      if (el !== tab) {
        el.setAttribute('aria-expanded', 'false')
        const controls = el.getAttribute('aria-controls') || ''
        const panel = document.getElementById(controls)
        panel?.setAttribute('aria-hidden', 'true')
      }
    })
  }
}
